var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const fetchGuidedRecipe = (id) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const response = yield fetch(`https://zapier.com/api/v4/guided-recipes/${id}`);
    if (!response.ok) {
        console.error('Error fetching Guided Recipe with ID ' + id);
        return;
    }
    // .catch and release here so that we can later filter out non-existant Guided Recipes in ZapCardSection.tsx
    const responseJSON = yield response.json().catch();
    if (responseJSON) {
        const services = (_a = responseJSON.services) === null || _a === void 0 ? void 0 : _a.map((service) => {
            var _a;
            return ({
                name: service.name,
                src: (_a = service.images) === null || _a === void 0 ? void 0 : _a.url_64x64,
            });
        });
        return {
            title: responseJSON.title,
            services,
            href: `https://zapier.com${responseJSON.guided_recipe_url}`,
            color: `#${(_b = responseJSON.head_service) === null || _b === void 0 ? void 0 : _b.primary_color}`,
        };
    }
});
//# sourceMappingURL=data.js.map